export const PROJECT_STATUS_ACTIVE = 'active';
export const PROJECT_STATUS_ARCHIVED = 'archived';
export const PROJECT_STATUS_ARCHIVE = 'archived';
export const PROJECT_STATUS_DELETED = 'deleted';
export const STATUS_SESSION_STORAGE_KEY = 'status';

export const CARD_VIEW = 'Card';
export const TABLE_VIEW = 'Table';
export const PROJECT_VIEW_SESSION_KEY = 'ProjectView';
export const INITIAL_TABLE_VIEW_PAGE_SIZE = 10;
export const CARD_VIEW_PAGE_SIZE = 12;
export const MAX_PROJECTS_TO_SHOW_IN_CAROUSEL = 10;
export const MOBILE_WIDTH = 639;
export const MOBILE_MEDIA = '(max-width: 639px)';

export const SORT_KEY_PROJECT_NAME = 'PROJECT_NAME';
export const SORT_KEY_PROJECT_STATUS = 'STATUS';
export const SORT_KEY_PROJECT_ID = 'PROJECT_ID';
export const SORT_KEY_LAST_MODIFIED = 'LAST_MODIFIED';

export const PROJECTS_SUMMARY_VIEW_TYPE = 'projects: project summary view type';
export const PROJECTS_SORT_SEARCH = 'projects: sort and search';
export const PROJECTS_PAGINATION = 'projects: pagination';
export const PROJECT_ENTRY_POINT = 'projects: entry point';